import React from 'react';
import { StyleSheet, View, TextInput } from 'react-native';
import { ParagraphBold } from '../../../components';
import { useLanguage } from '../../../locale';
import { SurveyQuestion } from '../../../api/survey/survey.models';

interface TextQuestionProps {
  question: SurveyQuestion;
  value?: string;
  onChange: (value: string) => void;
}

export const TextQuestion: React.FC<TextQuestionProps> = ({ 
  question, 
  value, 
  onChange 
}) => {
  const [t] = useLanguage();
  const { localizedContent } = question;
  
  // Content is already localized from the server
  const content = localizedContent;
  
  if (!content) return null;
  
  return (
    <View style={styles.container}>
      <ParagraphBold>{content.text}</ParagraphBold>
      
      <TextInput
        style={styles.textInput}
        value={value}
        onChangeText={onChange}
        placeholder={t('survey.detail.enterAnswer')}
        multiline
        numberOfLines={4}
        textAlignVertical="top"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
    paddingHorizontal: 4,
  },
  questionText: {
    marginBottom: 16,
  },
  textInput: {
    borderWidth: 1,
    borderColor: '#D1D1D6',
    borderRadius: 8,
    padding: 12,
    minHeight: 120,
    backgroundColor: '#FFFFFF',
  },
});
